import { NAP } from "@/lib/nap";

const FAQ_PAIRS = [
  {
    q: "How do I contact Siddhivinayak Group for a property enquiry?",
    a: "Reach the team via three channels: phone +91 98232 60303 (Mon–Sat, 10:00–19:00), email mail@kunalpadole.com (response within 4 working hours), or the website enquiry form which routes to a project-specific consultant. Walk-ins are welcome at the registered office in Raje Raghuji Nagar, Nagpur 440009.",
  },
  {
    q: "Can I book a free site visit in Nagpur?",
    a: "Yes. Free site visits are available across all five active projects — Hilltop Heights -14, Hilltop Heights -11, Embassy-10, Siddhivinayak Nagari, and Ayodhya City. Pick a 60-minute slot between 10:00 and 18:00 (Mon–Sat), and a project consultant will accompany you on-site with project brochures, layout plans, and sample flat walkthroughs.",
  },
  {
    q: "How quickly does Siddhivinayak Group respond to enquiries?",
    a: "Phone calls and walk-ins are answered in real time during business hours. Email and form enquiries receive a personalised response within 4 working hours. Site-visit requests are confirmed within 30 minutes during business hours and scheduled at the customer's preferred slot.",
  },
  {
    q: "Do I need to pay any fee to book a site visit or consultation?",
    a: "No. Site visits, project consultations, brochures, layout plans, and quote sheets are provided free of cost. There is no booking fee or commitment — Siddhivinayak Group's sales process is fully transparent at the enquiry stage.",
  },
  {
    q: "Which documents should I carry for the first site visit?",
    a: "Carry a government-issued photo ID (Aadhaar / PAN / Driving Licence) for verification at the site gate. If you want a same-day indicative quote, also carry your last 3 months' salary slips or ITR — the consultant can run an eligibility check for bank pre-approved loan offers on the spot.",
  },
  {
    q: "Can I get an online video tour instead of an in-person visit?",
    a: "Yes. Siddhivinayak Group offers live video tours via WhatsApp / Google Meet for outstation and NRI buyers. Each tour runs 30–45 minutes, covers the show flat, sample amenities, and site progress, and is recorded for later reference. Schedule a video tour by emailing mail@kunalpadole.com.",
  },
  {
    q: "Is there a dedicated point of contact after I express interest?",
    a: "Yes. Every enquiry is assigned a named project consultant who handles the customer through booking, agreement, loan processing, registration, and possession. The consultant's direct phone number and email are shared after the first interaction so all queries route to one person — not a call centre.",
  },
  {
    q: "What are the office hours for Siddhivinayak Group Nagpur?",
    a: "Office hours are Monday to Saturday, 10:00 to 19:00 IST. The office is closed on Sundays and public holidays declared by the Government of Maharashtra. For urgent support outside business hours, email mail@kunalpadole.com — enquiries are queued and addressed the next working day.",
  },
];

const ORG_ID = `${NAP.siteUrl}/#organization`;
const CONTACT_PAGE_ID = `${NAP.siteUrl}/contact#contactpage`;
const FAQ_ID = `${NAP.siteUrl}/contact#faq`;
const LOGO_URL = `${NAP.siteUrl}/img/logo.svg`;
const OG_IMAGE = `${NAP.siteUrl}/img/og/siddhivinayak-group-og.jpg`;

const organization = {
  "@type": ["Organization", "RealEstateAgent"],
  "@id": ORG_ID,
  name: NAP.brand,
  alternateName: NAP.legalName,
  url: NAP.siteUrl,
  logo: LOGO_URL,
  telephone: NAP.phone,
  email: NAP.email,
  address: {
    "@type": "PostalAddress",
    streetAddress: NAP.streetAddress,
    addressLocality: NAP.addressLocality,
    addressRegion: NAP.addressRegion,
    postalCode: NAP.postalCode,
    addressCountry: NAP.addressCountry,
  },
};

const contactPage = {
  "@type": "ContactPage",
  "@id": CONTACT_PAGE_ID,
  url: `${NAP.siteUrl}/contact`,
  name: "Contact Siddhivinayak Group | Site Visit Nagpur",
  description:
    "Contact Siddhivinayak Group for site visits, pricing, and project enquiries. Call +91 98232 60303 or visit our office at Raje Raghuji Nagar, Nagpur 440009.",
  inLanguage: "en-IN",
  isPartOf: { "@id": `${NAP.siteUrl}/#website` },
  about: { "@id": ORG_ID },
  primaryImageOfPage: { "@type": "ImageObject", url: OG_IMAGE },
};

const faqPage = {
  "@type": "FAQPage",
  "@id": FAQ_ID,
  url: `${NAP.siteUrl}/contact#faq`,
  isPartOf: { "@id": CONTACT_PAGE_ID },
  mainEntity: FAQ_PAIRS.map(({ q, a }) => ({
    "@type": "Question",
    name: q,
    acceptedAnswer: { "@type": "Answer", text: a },
  })),
};

const breadcrumb = {
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Home", item: NAP.siteUrl },
    {
      "@type": "ListItem",
      position: 2,
      name: "Contact",
      item: `${NAP.siteUrl}/contact`,
    },
  ],
};

export const CONTACT_SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [organization, contactPage, faqPage, breadcrumb],
};